module.exports = __webpack_public_path__ + "img/UTECHO-5.c1c45811.jpg";